import { Button } from 'antd';
import React from 'react';

interface ActionButtonsProps {
    /** Disabled until possession is set (events need a team). */
    disabled: boolean;
    onTimeout: () => void;
    onFoul: () => void;
    onGoal: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ disabled, onTimeout, onFoul, onGoal }) => (
    <div className="m-act">
        <Button className="m-act__btn" disabled={disabled} onClick={onTimeout}>
            Timeout
        </Button>
        <Button className="m-act__btn" disabled={disabled} onClick={onFoul}>
            Personal foul
        </Button>
        <Button className="m-act__btn m-act__btn--goal" disabled={disabled} onClick={onGoal}>
            Goal
        </Button>
    </div>
);

export default ActionButtons;
